import $ from "jquery";
import moment from "moment/moment";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import init from '../AccessControl/Check';
import { CSVLink } from "react-csv";
import number_format from "../../../components/Constants/NumberFormat"; 
import { SUPER_ADMIN, USER } from "../ConstRole/ConstRole";


const AllCompanies = (props) => {

    const pageName = "Company View";
    init(pageName);

    const [kamLists, setKamLists] = useState([]);
    const [userProfile, setUserProfile] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(0);
    const [reqParam, setReqParam] = useState({
        page: 1
    });

    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        id: ""
    });
    const [apiData, setApiData] = useState({});
    const [searchName, setSearchName] = useState("");
    const filterByNameAndKam = () => {
        // if( searchName?.toString().length === 0 ) {
        //     alert("Please enter name.");
        //     return;
        // }

        let kam_id = $("#kam_id").val() ?? "";
        setReqParam({ ...reqParam, name:searchName, kam: kam_id, page: 1 });
    }

    // useEffect(()=>{
    //     if(searchName?.toString().length === 0) {
    //         setReqParam({ ...reqParam, name: "", page: 1 });
    //         return;
    //     }

    // },[searchName]);


    // KAM lists
    useEffect(()=>{ 
        PostLoginGetApi("user/list/kam", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setKamLists(responseData["data"]["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    // Company List
    useEffect(() => {
        PostLoginGetApi("company", reqParam, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setCompanyList(responseData["data"]["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [isRefresh, reqParam]);

    const [excelData, setExcelData] = useState([]);
    const excelPrepare = () => {
        let i = 0;
        let arr  = ['','COMPANY REPORT'];
        arr[i++] = ['','DOWNLOAD AT', moment().format('DD MMM, YYYY hh:mm A')];
        arr[i++] = [];

        arr[i++] = [
            '#',
            'CODE',
            'APPROVED AT',
            'BUSINESS CATEGORY',
            'POSITION',
            'DOING BUSINESS AS',
            'COMPANY NAME',
            'SKU',
            'ADDRESS (TL)',
            'CURRENT ADDRESS',
            'PHONE',
            'EMAIL ADDRESS',
            'SETTLEMENT TYPE',
            'SETTLEMENT CHARGE / COMMISSION',
            'SETTLEMENT CYCLE',
            'SERVICE TYPE',
            'BANK ACCOUNT NAME',
            'BANK ACCOUNT NUMBER',
            'BANK NAME',
            'BANK BRANCH',
            'ROUTING NO',
            'PARTNER NAME',
            'PARTNER ADDRESS',
            'PARTNER PHONE',
            'PARTNER EMAIL ADDRESS',
            'POC NAME',
            'POC DESIGNATION',
            'POC PHONE',
            'POC EMAIL ADDRESS',
            'KAM NAME',
            'KAM PHONE',
            'KAM EMAIL ADDRESS',
            'OWNER NAME',
            'OWNER PHONE',
            'OWNER EMAIL ADDRESS',
            'LAST TRANSACTION AMOUNT',
            'LAST TRANSACTION DATE',
            'LAST SETTLEMENT AMOUNT',
            'LAST SETTLEMENT DATE',
            'IS SHOP OPEN',
            'CREATED / REQUESTED AT',
        ];


        // Get All Orders List
        PostLoginGetApi("company-all", reqParam, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    let data = responseData["data"] ?? [];
                    data.forEach((val, index) => {

                        let commission = val?.commission ?? "";
                        if( val?.commission_type === 1 ) {
                            commission = commission + "%";
                        }

                        let service_type = val?.service_type ?? "";
                        if( service_type.length >= 2 ) {
                            service_type = JSON.parse(service_type);
                            service_type = service_type.join(", ");
                        }

                        arr[i++] = [
                            index + 1,
                            val?.code ?? "",
                            val?.created_at ? moment(val.created_at).format("DD MMM, YYYY hh:mm A") : "",
                            val?.category?.name ?? "",
                            val?.position ?? "",
                            val?.name ?? "",            // Doing Business As
                            val?.name2 ?? "",           // Company Name
                            parseInt(val?.items_count ?? 0), // SKU
                            val?.address ?? "",
                            val?.current_address ?? "",
                            val?.phone ?? "",
                            val?.email ?? "",
                            val?.settlement_type ?? "",
                            commission,                 // Calculated earlier
                            val?.settlement_cycle ?? "",
                            service_type,               // Pre-calculated service type
                            val?.bank_account_name ?? "",
                            val?.bank_account_number ?? "",
                            val?.bank?.name ?? "",
                            val?.branch?.name ?? "",
                            val?.bank_routing ?? "",

                            // Partner Info
                            val?.partner_name ?? "",
                            val?.partner_address ?? "",
                            val?.partner_phone ?? "",
                            val?.partner_email ?? "",

                            // POC Info
                            val?.poc_name ?? "",
                            val?.poc_designation ?? "",
                            val?.poc_phone ?? "",
                            val?.poc_email ?? "",

                            // KAM Info
                            val?.kam?.name ?? "",
                            val?.kam?.mobile_no ?? "",
                            val?.kam?.email ?? "",

                            // Owner Info
                            val?.owner?.name ?? "",
                            val?.owner?.mobile_no ?? "",
                            val?.owner?.email ?? "",

                            // Last Booking (Transaction)
                            val?.latest_booking?.totalPrice ?? "",
                            val?.latest_booking?.createdAt ? moment(val.latest_booking.createdAt).format("DD MMM, YYYY hh:mm A") : "",

                            // Last Settlement
                            val?.latest_settlement?.total_payable ?? "-",
                            val?.latest_settlement?.created_at ? moment(val.latest_settlement.created_at).format("DD MMM, YYYY hh:mm A") : "-",
                            
                            // Shop Open
                            val?.settings?.is_open === 1 ? "Yes" : "No",

                            // Requested On
                            val?.registration?.created_at ? moment(val.registration.created_at).format("DD MMM, YYYY hh:mm A") : "-",
                        ];

                    });

                    setExcelData(arr);
                }
            }
        }).catch((err) => {
            toast.error("A problem occur. Please try again.");
            console.log(err);
        }).finally(()=>{
            return true;
        });
    }

    // Delete Company 
    const deleteCompany = (id) => {
        try {
            PostLoginPostApi("company/" + id, "", 3, 0, 3).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    var responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
                    if (responseData["code"] === 200) {
                        setDeleteModal(false);
                        toast.success("Company deleted");
                        setIsRefresh((prevCounter) => {
                            return prevCounter + 1;
                        });
                        return;
                    }

                    toast.error(responseData["messages"].toString());
                    return;

                }
            }).catch((error) => {
                toast.error("A problem occur. Please try again.");
                console.log(error);
            });
        }
        catch (exception) {
            toast.error("A problem occur.");
            console.log(exception);
        }
    }

    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    useEffect(() => {
        setUserProfile(props?.userProfile?.user_type);
    }, [props]);

    const showDropDown = event => {
        $(".dropdownDotsHorizontal").hide();
        event.currentTarget.nextSibling.style.display = "block";
    }

    document.addEventListener('scroll', function () {
        $(".dropdownDotsHorizontal").hide();
    }, true);

    $('body').on("click", function (e) {
        if (e.target?.parentElement?.className === "" || e.target?.parentElement?.className === null || e.target?.parentElement?.className === undefined) {
            return;
        }

        if (e.target.parentElement.className.toString().includes("dropdownMenuIconHorizontalButton mt-2") === false) {
            $(".dropdownDotsHorizontal").hide();
        }
    });

    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">

            {/** Left Side */}

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-0 pt-3">
                    
                    
                    <div className="w-1/4 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5">Here’s your Companies at a glance </h6>
                        <p className="pt-0 italic">Total: <strong>{(apiData?.total ?? 0)* 1}</strong></p>
                    </div>



                    {(userProfile === SUPER_ADMIN || userProfile === USER) &&
                        <div className="w-3/4 h-[68px] float-left text-right justify-end flex items-center">
                            <input type="search" id="search_by_name" name="search_by_name" value={searchName} onChange={(event)=>{setSearchName(event.currentTarget.value)}} placeholder="Search by company name" className="rounded-md w-[400px] h-[47px] border-gray-500"/>
                            <select name="kam_id" id="kam_id" className='ml-3 rounded border-solid border border-gray-500 h-[47px] w-[400px]' required>
                                <option value="">All KAM</option>
                                {kamLists?.map((data, index) => (
                                    <option key={index} value={data.id} data-name={data.name} data-email={data.email}
                                        data-phone={data.mobile_no} className='text-black'>{data.email}</option>
                                ))}
                            </select>
                            
                            
                            <button id="filter_btn" onClick={filterByNameAndKam} type="button" className="ml-2 bg-[#00D632] px-5 py-2 rounded-md text-white hover:opacity-75">Search</button>


                            <Link to={"/dashboard/company/create-company"} className="custom-btn ml-3 mr-1 text-center">Create Company</Link>

                            {(excelData.length === 0) ? 
                                <button onClick={excelPrepare} className="custom-btn ml-2 text-center">Prepare CSV</button>
                            :
                                <CSVLink className="custom-btn ml-2 text-center" filename={"company-report.csv"} onClick={() => {return true;} } data={excelData}>
                                    Export CSV
                                </CSVLink>
                            }
                        </div>
                    }

                </div>

                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-5">
                        <div className='-m-1.5 pt-0'>
                            <div className='p-1.5 min-w-full inline-block align-middle'>
                                <div className="border rounded-lg shadow">
                                    <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                        <thead className='bg-neutral-100'>
                                            <tr className='text-left'>
                                                <th scope="col" className="text-sm px-3 text-center">#</th>
                                                <th scope="col" className="text-sm pl-3 pr-2 py-3">Approval</th>
                                                <th scope="col" className="text-sm pl-3 pr-2 py-3">Basic Info</th>
                                                <th scope="col" className="text-sm px-2 py-3 text-center w-[60px]">SKU</th>
                                                <th scope="col" className="text-sm px-2 py-3">Service</th>
                                                <th scope="col" className="text-sm px-2 py-3 text-center">Comm.</th>
                                                <th scope="col" className="text-sm pl-3 pr-2 py-3">POC Info</th>
                                                {userProfile === SUPER_ADMIN &&
                                                    <th scope="col" className="text-sm pl-3 pr-2 py-3">KAM Info</th>
                                                }
                                                <th scope="col" className="text-sm pl-2 pr-2 py-3">Last Transaction</th>
                                                <th scope="col" className="text-sm pl-2 pr-2 py-3">Last Settlement</th>
                                                <th scope="col" className="text-sm pl-2 pr-1 py-3">Created</th>
                                                <th scope="col" className="text-sm px-2 py-3 text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='divide-y divide-gray-200'>
                                            {(companyList.length === 0) &&
                                                <tr key="0">
                                                    <td className='px-3 py-1 text-center' colSpan={12}>
                                                        <p className='py-4'>No company available</p>
                                                    </td>
                                                </tr>
                                            }

                                            {companyList.map((data, index) => (
                                                (data !== null) &&
                                                <tr key={index}>
                                                    <td className='border-r-2 text-center' title={moment(data.created_at).format('LTS')}>
                                                        <strong className="text-sm">{index+1}</strong>
                                                    </td>
                                                    <td className='pl-3 pr-2 py-4 border-r-2 text-sm' style={{textAlign: "left"}} title={moment(data.created_at).format('LTS')}>
                                                        <strong className="text-sm">{moment(data.created_at).format("ll")}</strong>
                                                        <br /> {data.category.name}
                                                    </td>
                                                    <td className='pl-3 pr-2 py-4 border-r-2 text-sm'>
                                                        <Link to={`/dashboard/company-details/${data.id}`} className='cursor-pointer text-[#0774E9]'>{data.name}</Link>
                                                            {(data?.id || data?.id > 0) && 
                                                                <span title={`${(data?.settings?.is_open === 1) ? `Active` : `Inactive`}`} className={`${(data?.settings?.is_open === 1) ? `bg-green-200` : `bg-red-400`} px-1.5 pt-0.5 pb-0 font-semibold text-xs float-right rounded-full`}>{data?.id}</span>
                                                            }
                                                        <br />
                                                        {data.email.toLowerCase()}
                                                    </td>
                                                    <td className={`px-2 py-3 border-r-2 text-sm text-center font-bold ${((data?.items_count ?? 0) > 0) ? `text-black` : `text-red-600` }`}>
                                                        {data?.items_count ?? 0}
                                                    </td>
                                                    <td className='px-2 py-4 border-r-2 text-sm'>
                                                        {data.service_type.length >= 2 ?
                                                            <>
                                                                {JSON.parse(data?.service_type || "[]").map((item, index) => (
                                                                    <span key={index}>
                                                                        {item}
                                                                        {index < JSON.parse(data?.service_type || "[]").length - 1 && <>,<br/></>}
                                                                    </span>
                                                                ))}
                                                            </>
                                                            :
                                                            <>-</>
                                                        }
                                                    </td>
                                                    <td className='px-4 border-r-2 text-center text-sm'>
                                                        {data.commission > 0 &&
                                                        <>
                                                            {data.commission}{(data.commission_type === 1) && "%"}
                                                        </>
                                                        }
                                                        <div
                                                            className={
                                                                `text-sm font-semibold ` +
                                                                (data?.settlement_type === "net_price"
                                                                ? "text-orange-400"
                                                                : "text-green-400")
                                                            }
                                                            >{data?.settlement_type}</div>
                                                    </td>
                                                    <td className='pl-3 pr-2 py-4 border-r-2 text-sm' style={{textAlign: "left"}}>
                                                        {data.poc_name} <br />
                                                        {data.poc_email?.toString().toLowerCase()}
                                                    </td>

                                                    {userProfile === "Super Admin" &&
                                                        <td className='pl-3 pr-2 py-4 border-r-2 text-sm'>
                                                            {data?.kam?.name} <br />
                                                            {data?.kam?.email?.toString().toLowerCase()}
                                                        </td>
                                                    }
                                                    {/* <td className='px-3 py-4 border-r-2'>{data.owner?.name}</td> */}
                                                    <td className='px-3 py-3 border-r-2 text-sm'>
                                                        {(data?.latest_booking) && 
                                                            (process.env.REACT_APP_CURRENCY_SYMBOL + " " + number_format(data?.latest_booking?.totalPrice ?? 0))
                                                        }<br/>

                                                        {data?.latest_booking?.createdAt &&
                                                            <>{moment(data?.latest_booking?.createdAt).add(12, "hours").format("ll")}</>
                                                        }


                                                    </td>
                                                    <td className='px-3 py-3 border-r-2'>
                                                        {(data?.latest_settlement) ? 
                                                            <span className="text-sm">
                                                            {(process.env.REACT_APP_CURRENCY_SYMBOL + " " + number_format(data?.latest_settlement?.total_payable ?? 0))}
                                                            <br/>
                                                            {moment(data?.latest_settlement?.created_at).format("ll")}
                                                            </span>
                                                        :
                                                            <>-</>
                                                        }
                                                    </td>

                                                    <td className='pl-2 pr-1 py-4 border-r-2 text-sm' style={{textAlign: "left"}}>
                                                        {(data?.registration) ? <>
                                                            {moment(data?.registration?.created_at).format("ll")}
                                                        </> : "-"}
                                                    </td>

                                                    <td className='px-2 py-3 text-center'>
                                                        <button onClick={showDropDown} data-dropdown-toggle="dropdownDotsHorizontal" className="dropdownMenuIconHorizontalButton mt-2">
                                                            <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"></path></svg>
                                                        </button>

                                                        <div className="dropdownDotsHorizontal hidden relative z-50">
                                                            <div className='absolute -ml-20 -mt-2 border border-[1px solid rgb(245, 245, 245)] bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'>
                                                                <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
                                                                    <li className='border-b-[1px] border-b-slate-100'>
                                                                        <Link to={"edit-company"} state={{ data: data }} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                            Edit
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <span onClick={() => setDeleteModal({ isShow: true, id: data?.id })} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                            Delete
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>


                                {(apiData?.from) !== undefined &&
                                    <>
                                        <p className='float-left mt-7'>
                                            {`Showing ${apiData?.from * 1} - ${apiData?.to * 1} out of ${apiData?.total * 1}`}
                                        </p>


                                        {(apiData?.next_page_url !== null && apiData?.next_page_url !== "") &&
                                            <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                                Next Page&nbsp;&nbsp;&rarr;
                                            </button>
                                        }

                                        {(apiData?.prev_page_url !== null && apiData?.prev_page_url !== "") &&
                                            <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                                &larr;&nbsp;&nbsp;Previous Page
                                            </button>
                                        }
                                    </>
                                }

                        </div>
                    </div>
                </div>


            </div>


            {/* Popup */}
            {((deleteModal?.isShow === true) && deleteModal.id !== "") ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to delete this company?</h3>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => deleteCompany(deleteModal.id)} className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => setDeleteModal(false)} className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </div>
    );
};

export default AllCompanies;